/**
 * scrollable-list.js
 * this should probably be in the menu-drawer as its really too specific for general use elsewhere
 */

import React from 'react';
import { List } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import useScrollPosition from 'utils/use-scroll-position';


const useStyles = makeStyles(theme => ({
  listContainer: {
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    '&.scrollable': {
      '& .MuiList-root': {
        paddingRight: 0,
        overflowX: 'hidden',
      },
      [theme.breakpoints.up('sm')]: {
        paddingRight: 19,
      }
    },
  },
  list: {
    overflowY: 'auto',
  },
}));

export default function ScrollableList(props) {
  const { children } = props;
  const classes = useStyles();
  const ref = React.useRef();
  const [scrollStatus, setScrollStatus] = React.useState({top: true, bottom: false});
  useScrollPosition(
    ({ isTop, isBottom, isScrollable }) => {
      setScrollStatus({
        top: isTop, 
        bottom: isBottom, 
        scrollable: isScrollable
      });
    }, 
    [], 
    ref,
  );

  return (
    <>
      <div className={clsx(
        'scrollable-list', 
        classes.listContainer, {
          'scrollable': scrollStatus.scrollable
        }
      )}>        
        <List 
          ref={ref}
          className={classes.list}
        >
          {children}
        </List>
      </div>
    </>
  );
}